module.exports = __webpack_public_path__ + "img/Photo from Debra Bates.9b10f2c5.jpg";